export default "__VITE_ASSET__89684a62__"